import Vue from 'vue'

export const filtersRegistry = () => {
  Vue.filter('getVideoStatusText', status => {
    switch (status) {
      case 'done':
        return 'Sẵn sàng để sử dụng'
      case 'queued':
      case 'queued-manual':
        return 'Đang được chuyển đổi'
      default:
        'Video lỗi trong quá trình tải lên'
    }
  })
  Vue.filter('getQuestionType', type => {
    switch (type) {
      case 'single-choice':
        return 'Trắc nghiệm 1 đáp án'
      case 'multiple-choice':
        return 'Trắc nghiệm nhiều đáp án'
      case 'fill-blank':
        return 'Trả lời ngắn'
      case 'true-false-choice':
        return 'Câu hỏi lựa chọn đúng/sai'
      case 'link-question':
        return 'Câu hỏi nối từ'
      case 'direct-fill-blank-group':
        return 'Điền trực tiếp vào câu hỏi'
      case 'group':
        return 'Nhóm câu'
      default:
        return ''
    }
  })
  Vue.filter('getQuestionTypeShort', type => {
    switch (type) {
      case 'single-choice':
        return '1LC'
      case 'multiple-choice':
        return 'NLC'
      case 'fill-blank':
        return 'TLN'
      case 'true-false-choice':
        return 'Đ/S'
      case 'link-question':
        return 'NT'
      case 'direct-fill-blank-group':
        return 'CHD'
      case 'group':
        return 'NC'
      default:
        return ''
    }
  })
}
